import { AlertOutlined, QuestionCircleOutlined, WarningOutlined } from "@ant-design/icons";
import React from "react";
import "./help.css";

export const HelpLine = ({ children, type='help', ...args }) => {
  return (
    <div {...args}>
      {type === 'help' ? <QuestionCircleOutlined style={{ marginRight: 8 }} /> : <WarningOutlined style={{ marginRight: 8, color: 'red' }} />}
      {children}
    </div>
  );
};
